// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"styles_formWrapper__3M6F_","form":"styles_form__1B64X","banner":"styles_banner__1tdyu","loading":"styles_loading__3li4t","select":"styles_select__2RAJy"};